/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CreateConnectionLinkRequest = core.serialization.object({
    endUserOriginId: core.serialization.string(),
    endUserOrganizationName: core.serialization.string(),
    endUserEmailAddress: core.serialization.string(),
    categories: core.serialization.list(core.serialization.string()),
    integration: core.serialization.string().optional(),
    linkExpiryMins: core.serialization.number().optional(),
    shouldCreateMagicLinkUrl: core.serialization.boolean().optional(),
});
